export const Logo = ({ dark = false, testid, compact = false }) => (
    <span className="flex select-none items-center gap-2.5" data-testid={testid}>
        <span
            className={`flex shrink-0 items-center justify-center overflow-hidden rounded-lg bg-white shadow-[0_4px_14px_rgba(29,78,216,0.25)] ${
                compact ? "h-9 w-9" : "h-11 w-11"
            }`}
        >
            <img
                src="/k1-logo.jpg"
                alt="K1 ELEVATOR'S logo"
                className="h-full w-full object-contain"
            />
        </span>
        <span className="leading-none">
            <span
                className={`block font-extrabold tracking-tight ${
                    compact ? "text-base" : "text-lg"
                } ${dark ? "text-white" : "text-[#0B1528]"}`}
            >
                K1 ELEVATOR&rsquo;S
            </span>
            {!compact && (
                <span
                    className={`mt-1 block text-[9px] font-bold uppercase tracking-[0.3em] ${
                        dark ? "text-[#60A5FA]" : "text-[#2563EB]"
                    }`}
                >
                    Patna &bull; Gaya &bull; Ranchi
                </span>
            )}
        </span>
    </span>
);
